import { useRef } from "react";

type FormValue = {
  [key: string]: any;
};

export function useForm(defaultValue: FormValue = {}) {
  const data = useRef(defaultValue);
  function setFieldValue(key: string, value: any) {
    data.current[key] = value;
  }
  function getFormValue() {
    return data.current;
  }
  return { setFieldValue, getFormValue };
}
